import { render, staticRenderFns } from "./CurveReport.vue?vue&type=template&id=6b7b59b6"
import script from "./CurveReport.vue?vue&type=script&lang=js"
export * from "./CurveReport.vue?vue&type=script&lang=js"
import style0 from "./CurveReport.vue?vue&type=style&index=0&id=6b7b59b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports